var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-btn',{staticClass:"secondary-button elevation-0 text-none",attrs:{"disabled":_vm.disabled,"height":"40","block":""},on:{"click":function($event){return _vm.onClick()}}},[_vm._v(_vm._s(_vm.name))])
}
var staticRenderFns = []

export { render, staticRenderFns }